/**
 * Two DIFFERENT articles closer than this are flagged on the calendar and in the
 * move dialog. The same number as the fill planner's `MIN_ARTICLE_GAP_MINUTES`
 * (keywords/src/social/backfill.ts), which never places two articles closer.
 */
export const ARTICLE_GAP_MINUTES = 180;
